module.exports = __webpack_public_path__ + "assets/img/video-btn-0302b2d5.png";